import React, { useState } from "react";
import {
  FaCheckCircle,
  FaEnvelope,
  FaMailBulk,
  FaPaperPlane,
} from "react-icons/fa";

import Reveal from "../../../components/ui/Reveal";
import SectionTitle from "../HomePage/SectionTitle";

import { saveMessageContactForm } from "../../../services/contactformServices";

const FormContact = ({ section }) => {
  const [notificationSent, setNotificationSent] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });

  if (!section) return null;

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setNotificationSent(false);
    setFormData((prevFormData) => ({ ...prevFormData, [name]: value }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    const { name, email, message } = formData;

    try {
      setSubmitting(true);

      await saveMessageContactForm({
        name,
        email,
        message,
        section_id: section.id,
      });

      setNotificationSent(true);
      setFormData({
        name: "",
        email: "",
        message: "",
      });
    } catch (error) {
      console.error("Erreur lors de l'envoi du message:", error);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <section
      id="contact"
      className="bg-white py-16 dark:bg-slate-950 sm:py-20"
    >
      <div className="mx-auto max-w-5xl px-4 sm:px-6 lg:px-8">
        <SectionTitle
          eyebrow="Contact"
          title="Contacter "
          highlight="l’association"
          subtitle={`Une question pour ${section.nom_section} ? Envoyez votre message via le formulaire.`}
        />

        <Reveal>
          <form
            className="overflow-hidden rounded-[2rem] border border-slate-200 bg-slate-50 p-5 shadow-xl dark:border-white/10 dark:bg-slate-900 sm:p-8"
            onSubmit={handleSubmit}
          >
            <div className="mb-7 flex items-center gap-4 rounded-2xl bg-white p-4 dark:bg-slate-950">
              <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl bg-primary/10 text-primary">
                <FaMailBulk />
              </span>

              <div>
                <p className="text-xs font-bold uppercase tracking-wide text-slate-400">
                  Destinataire
                </p>
                <p className="text-base font-bold text-slate-950 dark:text-white">
                  {section.nom_section}
                </p>
              </div>
            </div>

            <div className="grid gap-5 md:grid-cols-2">
              <div>
                <label
                  htmlFor="name"
                  className="mb-2 block text-sm font-bold text-slate-700 dark:text-slate-200"
                >
                  Nom Prénom
                </label>

                <input
                  type="text"
                  id="name"
                  name="name"
                  className="w-full rounded-2xl border border-slate-200 bg-white px-4 py-3 text-sm font-medium text-slate-800 outline-none transition focus:border-primary focus:ring-4 focus:ring-primary/10 dark:border-white/10 dark:bg-slate-950 dark:text-white"
                  placeholder="Votre nom"
                  required
                  value={formData.name}
                  onChange={handleInputChange}
                />
              </div>

              <div>
                <label
                  htmlFor="email"
                  className="mb-2 block text-sm font-bold text-slate-700 dark:text-slate-200"
                >
                  Votre email
                </label>

                <input
                  type="email"
                  id="email"
                  name="email"
                  className="w-full rounded-2xl border border-slate-200 bg-white px-4 py-3 text-sm font-medium text-slate-800 outline-none transition focus:border-primary focus:ring-4 focus:ring-primary/10 dark:border-white/10 dark:bg-slate-950 dark:text-white"
                  placeholder="mail@gmail.com"
                  required
                  value={formData.email}
                  onChange={handleInputChange}
                />
              </div>

              <div className="md:col-span-2">
                <label
                  htmlFor="message"
                  className="mb-2 block text-sm font-bold text-slate-700 dark:text-slate-200"
                >
                  Votre message
                </label>

                <textarea
                  id="message"
                  name="message"
                  rows="6"
                  className="w-full resize-none rounded-2xl border border-slate-200 bg-white px-4 py-3 text-sm font-medium text-slate-800 outline-none transition focus:border-primary focus:ring-4 focus:ring-primary/10 dark:border-white/10 dark:bg-slate-950 dark:text-white"
                  placeholder="Laissez votre message ici..."
                  value={formData.message}
                  onChange={handleInputChange}
                  required
                />
              </div>
            </div>

            <div className="mt-7 flex flex-col items-center justify-between gap-4 sm:flex-row">
              <div className="flex items-center gap-3 text-sm text-slate-500 dark:text-slate-300">
                <FaEnvelope className="text-primary" />
                Votre message sera transmis à l’association.
              </div>

              <button
                type="submit"
                disabled={submitting}
                className="inline-flex items-center justify-center gap-2 rounded-2xl bg-primary px-6 py-3 text-sm font-bold text-white shadow-lg transition hover:-translate-y-0.5 hover:shadow-xl disabled:cursor-not-allowed disabled:opacity-60"
              >
                {submitting ? "Envoi..." : "Envoyer"}
                <FaPaperPlane />
              </button>
            </div>

            {notificationSent && (
              <div className="mt-5 flex items-center justify-center gap-2 rounded-2xl border border-emerald-200 bg-emerald-50 px-4 py-3 text-sm font-bold text-emerald-700 dark:border-emerald-500/20 dark:bg-emerald-500/10 dark:text-emerald-300">
                <FaCheckCircle />
                Votre message a bien été envoyé.
              </div>
            )}
          </form>
        </Reveal>
      </div>
    </section>
  );
};

export default FormContact;